import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseApi, BASE_URL } from "@edl-development/edl-common";
import { DateTimeDTO } from "src/app/model/date-time-dto.model";
import { CreateObservationDTO } from "src/app/model/observation/diff/diff-create-dto.model";
import { NTPERubricSaveDTO } from "src/app/model/observation/ntpe/ntpe-save-rubric-dto.model";
import { NtpeModel } from "src/app/model/observation/ntpe/ntpe.model";
import { ObservationSummaryDTO } from "src/app/model/observation/observation-summary-dto.model";

@Injectable()
export class NtpeApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getDetails(observationId: string) {
        return this.http.get<NtpeModel>(this.baseUri + '/observation/ntpe/' + observationId, {});
    }

    createNtpe(createObservationDto: CreateObservationDTO) {
        return this.http.post<ObservationSummaryDTO>(this.baseUri + '/observation/ntpe/create', createObservationDto);
    }

    approveActionPlan(observationId: string) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/approveActionPlan', {});
    }

    changeFocusArea(observationId: string, componentId: number, focused: boolean) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/focus/' + componentId, focused);
    }

    completeConference(observationId: string, complete: boolean) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/completeConference', complete );
    }

    completePreConference(observationId: string, complete: boolean) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/completePreConference', complete);
    }

    save(ntpeModel: NtpeModel) {
        return this.http.put(this.baseUri + '/observation/ntpe/save', ntpeModel);
    }

    onSubmitActionPlan(observationId: string) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/submitActionPlan', {});
    }

    saveNTPERubric(ntpeRubricSaveDTO: NTPERubricSaveDTO) {
        return this.http.put(this.baseUri + '/observation/ntpe/saveRubric', ntpeRubricSaveDTO);
    }

    scheduleConference(observationId: string, date: DateTimeDTO) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/scheduleConference', date);
    }

    schedulePreConference(observationId: string, date: DateTimeDTO) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/schedulePreConference', date);
    }

    submitUpdate(ntpeRubricSaveDTO: NTPERubricSaveDTO) {
        return this.http.put(this.baseUri + '/observation/ntpe/submitUpdate', ntpeRubricSaveDTO);
    }

    submitRating(ntpeRubricSaveDTO: NTPERubricSaveDTO) {
        return this.http.put(this.baseUri + '/observation/ntpe/submitRating', ntpeRubricSaveDTO);
    }

    submitFeedback(observationId: string) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/feedback', {});
    }

    submitSignature(observationId: string, signature: string) {
        return this.http.put(this.baseUri + `/observation/ntpe/${observationId}/submitSignature/` + signature, {});
    }

    unauthenticate(observationId: string) {
        return this.http.put(this.baseUri + `/observation/ntpe/${observationId}/unauthenticate/`, {});
    }

    approveMidYearUpdate(observationId: string) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/approveMidYearUpdate', {});
    }

    submitMidYearUpdate(ntpeRubricSaveDTO: NTPERubricSaveDTO) {
        return this.http.put(this.baseUri + '/observation/ntpe/submitMidYearUpdate', ntpeRubricSaveDTO);
    }

    approveEndYearUpdate(observationId: string) {
        return this.http.put(this.baseUri + '/observation/ntpe/' + observationId + '/approveEndYearUpdate', {});
    }
    
    submitEndYearUpdate(ntpeRubricSaveDTO: NTPERubricSaveDTO) {
        return this.http.put(this.baseUri + '/observation/ntpe/submitEndYearUpdate', ntpeRubricSaveDTO);
    }
}